import script from "./VariableInsertTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./VariableInsertTextarea.vue?vue&type=script&setup=true&lang=js"

import "./VariableInsertTextarea.vue?vue&type=style&index=0&id=7f4ade28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f4ade28"]])

export default __exports__